(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["linkup-email-popup"]) return;
  try {
    
  (() => {
    const key = 'linkup97-newsletter-until-v1';
    const read = () => { try { return Number(localStorage.getItem(key)) || 0; } catch { return 0; } };
    const remember = days => { try { localStorage.setItem(key, String(Date.now() + days * 86400000)); } catch {} };
    const init = root => root.querySelectorAll('.lu-popup:not([data-ready])').forEach(dialog => {
      dialog.dataset.ready = 'true';
      const editor = dialog.dataset.editor === 'true';
      const success = dialog.querySelector('[data-lu-success]');
      const error = dialog.querySelector('[data-lu-error]');
      const result = success || error;
      let previous;
      const show = () => {
        if (!dialog.isConnected || dialog.open) return;
        if (document.querySelector('dialog[open]')) return;
        previous = document.activeElement;
        dialog.showModal();
        if (result) result.focus();
      };
      const dismiss = () => { if (!editor) remember(success ? 365 : 7); dialog.close(); };
      dialog.querySelectorAll('[data-lu-close]').forEach(button => button.addEventListener('click', dismiss));
      dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
      dialog.addEventListener('close', () => { if (previous && previous.isConnected) previous.focus(); });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dismiss();
      });
      if (result) { if (success && !editor) remember(365); show(); return; }
      if (editor) { show(); return; }
      if (read() > Date.now() || /\/(cart|checkout|challenge|account)(\/|$)/.test(location.pathname)) return;
      setTimeout(() => { if (read() <= Date.now()) show(); }, Number(dialog.dataset.delay) * 1000);
    });
    init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["linkup-last20-popup"]) return;
  try {
    
(() => {
  const startedKey = 'lu-last20-start-v1';
  const seenKey = 'lu-last20-seen-v1';
  const get = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const set = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
  const init = root => root.querySelectorAll('.lu-last20:not([data-ready])').forEach(dialog => {
    dialog.dataset.ready = 'true';
    const editor = dialog.dataset.editor === 'true';
    const end = Date.parse(dialog.dataset.end);
    let previous;
    let timer;
    const close = () => dialog.close();
    dialog.querySelectorAll('[data-last20-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    dialog.addEventListener('close', () => { if (previous?.isConnected) previous.focus(); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
    });
    if (/\/(cart|checkout|challenge|account)(\/|$)/.test(location.pathname)) return;
    if (!editor && (Date.now() >= end || get(seenKey))) return;
    let started = Number(get(startedKey));
    if (!started || started > Date.now()) { started = Date.now(); set(startedKey, String(started)); }
    const tryShow = () => {
      if (!dialog.isConnected || dialog.open) return;
      if (!editor && (Date.now() >= end || get(seenKey))) return;
      const blocked = document.hidden || document.querySelector('dialog[open], [role="dialog"][aria-hidden="false"]');
      if (blocked) { timer = setTimeout(tryShow, 500); return; }
      previous = document.activeElement;
      dialog.showModal();
      if (!editor) {
        set(seenKey, '1');
        setTimeout(() => { if (dialog.open) dialog.close(); }, Math.max(0, end - Date.now()));
      }
    };
    timer = setTimeout(tryShow, editor ? 0 : Math.max(0, 30000 - (Date.now() - started)));
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(dialog)) clearTimeout(timer); });
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
